namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_chart, {

		background: {
			color: $mol_theme.card,
		},

		Filters_add: {
			width: 'fit-content',
		},

		Fullsize_wrapper: {
			height: '100%',
		},

	} )
	
}
